import $ from "jquery";

const defaults = {
    selector: {
        video: ".js-video",
        control: ".js-video-control",
    },
    state: {
        active: "is-active",
    },
    responsive: {
        desktop: 768,
        activeSize: "",
    },
};

let options;

const togglePlayPause = (e, video, control) => {
    $(control).toggleClass(options.state.active);

    control.each(function () {
        const activeAria = $(this).attr("aria-hidden") === "true";
        $(this).attr("aria-hidden", !activeAria);
    });

    // play / pause video
    if (video[0].paused === false) {
        video[0].pause();
    } else {
        video[0].play();
    }
};

const getScreenSize = (width) => {
    return width < options.responsive.desktop ? "mobile" : "desktop";
};

const loadResponsiveVideo = (video, source, size, firstLoad) => {
    if (firstLoad || size !== options.responsive.activeSize) {
        if (!firstLoad) {
            options.responsive.activeSize = size;
        }

        video.attr("poster", video.attr(`data-${size}-poster`));
        video[0].pause();
        source.attr("src", video.attr(`data-${size}-url`));
        video[0].load();
        video[0].play();
    }
};

function init(opts = {}) {
    // merge options
    options = $.extend(true, defaults, opts);
    options.responsive.activeSize = getScreenSize($(window).width());

    $(options.selector.video).each(function () {
        const videoElement = $(this).find("video");
        const videoSource = videoElement.find("source");
        const videoControl = $(this).find(options.selector.control);

        loadResponsiveVideo(
            videoElement,
            videoSource,
            getScreenSize($(window).width()),
            true,
        );

        $(window).on("resize", function () {
            loadResponsiveVideo(
                videoElement,
                videoSource,
                getScreenSize($(window).width()),
                false,
            );
        });

        // bind events
        $(videoControl).on("click", (e) => {
            togglePlayPause(e, videoElement, videoControl);
        });
    });
}

export default {
    init,
};
